import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryViewFilterButton`

export default defineMessages({
  viewingAccess: {
    id: `${scope}.viewingAccess`,
    defaultMessage: 'Has Viewing Access',
  },
  departments: {
    id: `${scope}.departments`,
    defaultMessage: 'Department',
  },
  accountCodes: {
    id: `${scope}.accountCodes`,
    defaultMessage: 'Account Code',
  },
  budgetType: {
    id: `${scope}.budgetType`,
    defaultMessage: 'Budget type',
  },
  budgetCategoryType: {
    id: `${scope}.budgetCategoryType`,
    defaultMessage: 'Budget Category type',
  },
  clearFilterButtonLabel: {
    id: `${scope}.clearFilterButtonLabel`,
    defaultMessage: 'Clear filters',
  },
  saveFilterButtonLabel: {
    id: `${scope}.saveFilterButtonLabel`,
    defaultMessage: 'Saved filters',
  },
})
